import RootState from '../../types';

export const selectHasVideoEntryAwarded = (state: RootState) => state.user.hasVideoEntryAwarded;

export const selectUserId = (state: RootState) => state.user.id;
